export default __webpack_public_path__ + "assets/f3ee3feb72d09ceea0994c1fb1c3f2e7.svg";